import _ from "lodash";
import type { IAuth } from "models/auth.model";
import { create } from "zustand";

import CommonHostStoreEventEmitter from "./HostStore.emitters";
import type { HostStoreType } from "./HostStore.type";
import { Environment, ProductEnvironment } from "models/environment.model";

const useSharedHostStore = create<HostStoreType>()((set) => ({
    auth: null,
    productEnvironments: [],
    isSystemTokenSet: false,
    setAuth: (auth: IAuth | null) =>
        set((state) => {
            if (!auth) {
                return { auth: null };
            }
            const { name, productName, isLoggedIn, userId, organizationId, productId, email, image } = auth;

            return {
                auth: {
                    name,
                    productName,
                    isLoggedIn,
                    userId,
                    organizationId,
                    productId,
                    email,
                    image
                }
            };
        }),
    setEnvironment: (environment: Environment) => {
        return set((state) => {
            if (!state.auth) {
                return state;
            }

            let updatedAuth = _.cloneDeep(state.auth);
            updatedAuth = { ...updatedAuth, environment };
            return { auth: updatedAuth };
        });
    },
    setProductEnvironments: (environments: ProductEnvironment[]) => {
        set(() => ({
            productEnvironments: environments
        }));
    },
    navigateFromHost: (url: string) => {
        CommonHostStoreEventEmitter.navigateFromHostHandler(url);
    },
    setIsSystemTokenSet: (flag: boolean) => {
        set(() => ({
            isSystemTokenSet: flag,
        }));
    }
}));

export const HostStoreEventEmitter = CommonHostStoreEventEmitter;
export const useHostStore = useSharedHostStore;
